/* eslint-disable babylonjs/available */
/* eslint-disable jsdoc/require-jsdoc */
import { Observable } from "core/Misc/observable.js";
import { StateManager } from "shared-ui-components/nodeGraphSystem/stateManager.js";
import { LockObject } from "shared-ui-components/tabs/propertyGrids/lockObject.js";
import { SmartFilter } from "smart-filters";
import { RegisterDefaultInput } from "./graphSystem/registerDefaultInput.js";
import { RegisterElbowSupport } from "./graphSystem/registerElbowSupport.js";
import { RegisterNodePortDesign } from "./graphSystem/registerNodePortDesign.js";
import { BlockTools } from "./blockTools.js";
import { PreviewSizeManager } from "./previewSizeManager.js";
const PreviewBackgroundStorageKey = "PreviewBackground";
export const ForceWebGL1StorageKey = "ForceWebGL1";
export class GlobalState {
    get previewBackground() {
        return this._previewBackground;
    }
    set previewBackground(value) {
        this._previewBackground = value;
        localStorage.setItem(PreviewBackgroundStorageKey, value);
    }
    constructor(engine, onNewEngine, onSmartFilterLoadedObservable, optimizerEnabled, optimizerDebugMode, smartFilter, blockEditorRegistration, hostElement, beforeRenderObservable, rebuildRuntime, reloadAssets, texturePresets, downloadSmartFilter, loadSmartFilterAsync, copySmartFilterToClipboard, copySmartFilterToStringAsync, pasteSmartFilterFromClipboardAsync, pasteSmartFilterFromStringAsync, saveToSnippetServer, addCustomBlock, deleteCustomBlock, clearCustomBlocks, onLogRequiredObservable, onSaveEditorDataRequiredObservable) {
        this.previewSizeManager = new PreviewSizeManager();
        this.forceWebGL1 = !!localStorage.getItem(ForceWebGL1StorageKey);
        this.onClearUndoStack = new Observable();
        this.pointerOverCanvas = false;
        this.onGetNodeFromBlock = () => null;
        this.onPopupClosedObservable = new Observable();
        this.onZoomToFitRequiredObservable = new Observable();
        this.onReOrganizedRequiredObservable = new Observable();
        this.onResetRequiredObservable = new Observable();
        this.onPreviewResetRequiredObservable = new Observable();
        this.mcpSessionUrl = null;
        this.mcpSessionConnected = false;
        this.mcpEventSource = null;
        this.onMcpSessionStateChangedObservable = new Observable();
        this.onlyShowCustomBlocksObservable = new Observable();
        const allowEdits = !!rebuildRuntime;
        if (allowEdits) {
            this.lockObject = new LockObject();
        }
        else {
            this.lockObject = new ReadOnlyLock();
        }
        this.stateManager = new StateManager();
        this.stateManager.data = this;
        this.stateManager.lockObject = this.lockObject;
        this.stateManager.getPortColor = (portData) => {
            return BlockTools.GetColorFromConnectionNodeType(portData.data.type);
        };
        RegisterElbowSupport(this.stateManager);
        RegisterNodePortDesign(this.stateManager);
        RegisterDefaultInput(this.stateManager);
        this.engine = engine;
        this.onNewEngine = onNewEngine;
        this.onSmartFilterLoadedObservable = onSmartFilterLoadedObservable;
        this.optimizerEnabled = optimizerEnabled;
        this.optimizerDebugMode = optimizerDebugMode;
        this.smartFilter = smartFilter ?? new SmartFilter("New Filter");
        this.blockEditorRegistration = blockEditorRegistration;
        this.hostElement = hostElement;
        this.hostDocument = hostElement.ownerDocument;
        this.hostWindow = hostElement.ownerDocument.defaultView;
        this.stateManager.hostDocument = this.hostDocument;
        this.downloadSmartFilter = downloadSmartFilter;
        this.loadSmartFilterAsync = loadSmartFilterAsync;
        this.copySmartFilterToClipboard = copySmartFilterToClipboard;
        this.copySmartFilterToStringAsync = copySmartFilterToStringAsync;
        this.pasteSmartFilterFromClipboardAsync = pasteSmartFilterFromClipboardAsync;
        this.pasteSmartFilterFromStringAsync = pasteSmartFilterFromStringAsync;
        this.saveToSnippetServer = saveToSnippetServer;
        this.texturePresets = texturePresets || [];
        this.beforeRenderObservable = beforeRenderObservable;
        this.rebuildRuntime = rebuildRuntime;
        this.reloadAssets = reloadAssets;
        this.addCustomBlock = addCustomBlock;
        this.deleteCustomBlock = deleteCustomBlock;
        this.clearCustomBlocks = clearCustomBlocks;
        this.onLogRequiredObservable = onLogRequiredObservable ?? new Observable();
        this.onSaveEditorDataRequiredObservable = onSaveEditorDataRequiredObservable ?? new Observable();
        this._previewBackground = localStorage.getItem(PreviewBackgroundStorageKey) ?? "grid";
    }
}
// TODO: remove once GraphCanvas supports readonly mode
class ReadOnlyLock {
    get lock() {
        return true;
    }
    set lock(_value) {
        // Ignore
    }
}
//# sourceMappingURL=globalState.js.map